import { PRICE_POLICIES_GET_STOCK_BEGIN,
    PRICE_POLICIES_GET_STOCK_SUCCESS,
    PRICE_POLICIES_GET_STOCK_FAILURE } from '../constants'

export function reducer(state, action) {

    switch (action.type) {
        case PRICE_POLICIES_GET_STOCK_BEGIN:
            return {
                ...state,
                stockDataPending: action.data.stockDataPending,
                stockData: action.data.stockData,
                factoryDiscount: action.data?.factoryCarLotDiscount?.factory_discount,
                carLotDiscount: action.data?.factoryCarLotDiscount?.car_lot_discount,
                backConventional: false
            }
        case PRICE_POLICIES_GET_STOCK_SUCCESS:
            return {
                ...state,
                stockDataPending: action.data.stockDataPending,
                stockData: action.data.stockData,
                factoryDiscount: action.data?.factoryCarLotDiscount?.factory_discount,
                carLotDiscount: action.data?.factoryCarLotDiscount?.car_lot_discount,
            }
        case PRICE_POLICIES_GET_STOCK_FAILURE:
            return{ 
                ...state,
                stockDataPending: action.data.stockDataPending
            }
        default:
            return state
    }
}
